import { db } from './firebase.js';
import { doc, getDoc, setDoc, updateDoc, collection, getDocs } from 'firebase/firestore';

export const UserService = {
    // Asegurar que el usuario existe en Firestore
    async syncUserProfile(user) {
        try {
            const userRef = doc(db, "users", user.uid);
            const userSnap = await getDoc(userRef);
            const isMasterAdmin = user.email === 'alberto.rampoldi@gmail.com';

            if (!userSnap.exists()) {
                // Crear perfil inicial
                const newUser = {
                    uid: user.uid,
                    displayName: user.displayName,
                    email: user.email,
                    photoURL: user.photoURL,
                    role: isMasterAdmin ? 'abogado_titular' : 'abogado_asociado',
                    createdAt: new Date(),
                    lastLogin: new Date(),
                    metadata: {},
                    settings: { notifications: true },
                    extensions: {}
                };
                await setDoc(userRef, newUser);
                return newUser;
            } else {
                // Actualizar último login Y FORZAR ROL SI ES MASTER ADMIN
                const updates = {
                    lastLogin: new Date()
                };

                // Critical Fix: Ensure Master Admin always has the role, even if created before logic existed
                if (isMasterAdmin && userSnap.data().role !== 'abogado_titular') {
                    updates.role = 'abogado_titular';
                }

                await updateDoc(userRef, updates);
                return { ...userSnap.data(), ...updates };
            }
        } catch (e) {
            console.error("Error sincronizando perfil:", e);
            throw e;
        }
    },

    async getUserData(uid) {
        const userSnap = await getDoc(doc(db, "users", uid));
        return userSnap.exists() ? userSnap.data() : null;
    },

    async updateUserProfile(uid, data) {
        try {
            const userRef = doc(db, "users", uid);
            await updateDoc(userRef, data);
            return true;
        } catch (e) {
            console.error("Error actualizando perfil:", e);
            throw e;
        }
    },

    // Obtener todos los usuarios (Solo para Admin)
    async getAllUsers() {
        try {
            const usersRef = collection(db, "users");
            const snapshot = await getDocs(usersRef);
            return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        } catch (e) {
            console.error("Error obteniendo usuarios:", e);
            return [];
        }
    }
};
